const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

const getMultiples = (isMultiple) => {
    if (isMultiple) {
        return 'Multiple';
    } else {
        return '';
    }
};

const getTexts = (amountFilesLimit, maxLengthFileName, maxSize, multiples, validTypesFile) => {
    const validTypesFiles = validTypesFile.filter( extension => extension !== 'jpeg');

    return {
        selectedFile: <FormattedText value={`dragNDropUpload-selectedFile${multiples}`} />,
        actualFile: <FormattedText value={`dragNDropUpload-actualFile${multiples}`} />,
        supportedFormats: <FormattedText value="dragNDropUpload-supportedFormats" injectedStrings={[validTypesFiles.join(', ').toUpperCase()]} />,
        sizeLimit: <FormattedText value="dragNDropUpload-sizeDescription" injectedStrings={[maxSize / 1024]} />,
        sizeError: <FormattedText value={`dragNDropUpload-sizeError${multiples}`} injectedStrings={[maxSize]} />,
        typeError: <FormattedText value="dragNDropUpload-typeError" injectedStrings={[validTypesFiles.join(', ')]} />,
        maxLengthError: <FormattedText value={`dragNDropUpload-maxLengthError${multiples}`} injectedStrings={[maxLengthFileName]} />,
        whiteListError: <FormattedText value="dragNDropUpload-whiteListError" />,
        ammountFilesLimitError: <FormattedText value="dragNDropUpload-ammountFilesLimitError" injectedStrings={[amountFilesLimit]} />
    }
};

const getTextDescription = (isMultiple) => {
    if (isMultiple) {
        return <FormattedText value="dragNDropUpload-defaultDescriptionMultiple" />;
    } else {
        return <FormattedText value="dragNDropUpload-defaultDescription" />;
    }
};

const getTextLinkDescription = (isMultiple) => {
    if (isMultiple) {
        return <FormattedText value="dragNDropUpload-defaultDescriptionSelectFiles" />;
    } else {
        return <FormattedText value="dragNDropUpload-defaultDescriptionSelectFile" />;
    }
};

module.exports = {
    getMultiples,
    getTexts,
    getTextDescription,
    getTextLinkDescription
};
